import { identityAccountId, IdentityAccountId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountDeleteCmd {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountDeleteCmd.validationSchema()
  );

  constructor(readonly value: IAMAccountDeleteCmdRaw) {
    JsonSchemaValidator.assert(IAMAccountDeleteCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId"],
      properties: {
        accountId: identityAccountId
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountDeleteCmdRaw {
  accountId: IdentityAccountId;
}
